import Button from '../Button';
import { Dropdown } from '../Dropdown';
import type { ButtonProps } from '../Button';

const renderIcon = (buttonProps?: Partial<ButtonProps>) => {
  return (
    <Button
      {...buttonProps}
      icon={buttonProps?.icon ?? 'more'}
      type={buttonProps?.type ?? 'light'}
    />
  );
};

export type ActionType = Omit<ButtonProps, 'label'> & {
  label: React.ReactNode;
};

type MoreActionsProps = {
  buttons?: (ActionType | boolean)[];
  buttonProps?: Partial<ButtonProps>;
};

const remapOption = (action: ActionType, index: number): OptionType => {
  return {
    value: String(index),
    label: (
      <Button
        key={String(index)}
        {...action}
        width="full"
        className="min-w-[20rem]"
      />
    ),
  };
};

export const MoreActions: React.FC<MoreActionsProps> = ({
  buttons,
  buttonProps,
}) => {
  const theseOptions: OptionType[] = buttons?.length
    ? buttons
        .filter(action => typeof action !== 'boolean')
        .map((action, index) => remapOption(action, index))
    : [{ value: '', label: 'No Options' }];

  return (
    <div onClick={e => e.stopPropagation()}>
      <Dropdown
        withArrow={false}
        onChange={() => 1}
        options={theseOptions}
        renderOption={({ option }) => option.label}
        renderValue={() => renderIcon(buttonProps)}
      />
    </div>
  );
};
